<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-dialog
    v-model="display"
    width="476"
    dark
  >
    <template v-slot:activator="{ on, attrs }">
      <img
        v-bind="attrs"
        class="abt_icon"
        :src="require(`@/assets/icons/icon_i.svg`)"
        alt="about-icon"
        v-on="on"
      >
    </template>

    <v-card class="about" height="285">
      <v-card-title class="pa-4 pl-11">
        <div>
          {{ `${$t('about.title')} ${$t('about.iot_connected_platform')}` }}
        </div>
        <v-icon class="close-icon" @click="display = false">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-11">
        <v-col class="pa-0">
          <v-row>
            <v-col class="py-0 pb-11">
              <span class="label">{{ $t('about.content.version') }}</span>
              <span v-if="i18n.locale === 'fr'" class="label">&nbsp;:&nbsp;</span>
              <span v-else class="label">:&nbsp;</span>
              <span class="content">{{ version }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <a class="document" :href="userGuide" download>{{ $t('about.content.userGuide') }}</a>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import moment from 'moment';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n-composable';

const display = ref(false);
const i18n = useI18n();
/**
   * Display full release name and publish date
   * Format is always prefixed with "release_date" and can have additional data after that
   * If LastRelease, don't display the rest of the string
   */
const version = computed(() => {
  const currentVersion = config.VUE_APP_VERSION || process.env.VUE_APP_VERSION;
  let displayedRelease = '';
  if (currentVersion) {
    const release = currentVersion.split('_');
    if (release[0] === 'LastRelease') {
      displayedRelease = `LastRelease - (${moment(release[1], 'YYYYMMDDHHmmss').format('D MMM YYYY HH:mm:ss')})`;
    } else {
      displayedRelease = `${currentVersion} - (${moment(release[1], 'YYYYMMDDHHmmss').format('D MMM YYYY HH:mm:ss')})`;
    }
  }
  return displayedRelease;
});

const userGuide = computed(() => '/documents/Tolling_Proxy_User_Guide_R515.pdf');

</script>
<style lang="scss" scoped>
@import './styles/about.scss';
</style>
